import React from "react";

import styled, { css } from "styled-components";

import PropTypes from "prop-types";

const fontSizes = {
    small: "1.2rem",
    regular: "1.4rem",
    large: "1.6rem",
};

const fontWeights = {
    regular: "400",
    bold: "500",
};

const StyledTextContainer = styled.div`
    font-size: ${({ fontSize }) => fontSizes[fontSize]};
    font-weight: ${({ fontWeight }) => fontWeights[fontWeight]};

    ${({ color }) => color && `color: ${color};`}

    /* withBarType prop이 true이면 왼쪽 바 스타일 적용 */
  ${({ withBarType }) =>
        withBarType &&
        css`
            padding-left: 8px; /* 왼쪽 바와 텍스트 사이 간격 */
            border-left: 2px solid var(--color-TitleBar);
        `}

  /* 기본 스타일 추가 영역 */
  line-height: 1.4;
`;

function StyledText({ children, fontSize, fontWeight, color, withBarType, ...rest }) {
    return (
        <StyledTextContainer
            fontSize={fontSize}
            fontWeight={fontWeight}
            color={color}
            withBarType={withBarType}
            {...rest}
        >
            {children}
        </StyledTextContainer>
    );
}

StyledText.propTypes = {
    /** 텍스트 내용 */
    children: PropTypes.node.isRequired,
    /** 텍스트 크기 */
    fontSize: PropTypes.oneOf(["small", "regular", "large"]),
    /** 텍스트 굵기 */
    fontWeight: PropTypes.oneOf(["regular", "bold"]),
    /** 텍스트 색상 (CSS color 값) */
    color: PropTypes.string,
    /** 왼쪽에 강조 바 표시 여부 */
    withBarType: PropTypes.bool,
};

StyledText.defaultProps = {
    fontSize: "regular",
    fontWeight: "regular",
    color: null,
    withBarType: false,
};

export default StyledText;
